$(window).load(function() {

	/* ---------------------------------------- */
	/* ----- >>> Retina Display --------------- */
	/* ---------------------------------------- */

	var pixelRatio = !!window.devicePixelRatio ? window.devicePixelRatio : 1;
	if (pixelRatio > 1) {
		$('img').each(function() {
			$(this).attr('src', $(this).attr('src').replace("@1x","@2x"));
		});
	}

	if(!Modernizr.svg) {
		$('img[src*="svg"]').attr('src', function() {
				return $(this).attr('src').replace('.svg', '.png');
		});
	}
	
});

$(document).ready(function () {

	setTimeout(function(){
		$('.setPopup').addClass('isSmall');
	},4000); 

	/* ---------------------------------------- */
	/* ----- >>> Modals ----------------------- */
	/* ---------------------------------------- */

	$('[data-fancybox]').fancybox({
		protect		: true,
		toolbar  	: true,
		infobar		: false,
		smallBtn 	: false,
		scrolling	: 'no',
	});

	/* ---------------------------------------- */
	/* ----- >>> Main Menu -------------------- */
	/* ---------------------------------------- */

	if($(window).width() < 640) {
		$('.setMenu').click(function(){
			$('.setMenu .setIcon').toggleClass('isOpen');
			$('.getNav').slideToggle('fast');
		});

		$('.getNav a[href^="#"]').click( function(e) {
			$(this).parent().toggleClass('isOpen');
			$(this).next().slideToggle('fast');
		});

	}
	
	$('.setPopup > div:first-child').click(function(){
		var setOpen  = $('span',this).data('open');
		var setClose = $('span',this).data('close');
		console.log(setClose)
		$('.setPopup').toggleClass('setOpen');
		$('.setPopup span').text($('.setPopup span').text() == setOpen ? setClose : setOpen);
	});


	$('.isType > li').click(function() {
		$(this).parent().find('.isActive').removeClass('isActive');
		$(this).addClass('isActive');
		if ($(this).hasClass('getPro')) {
			$('#isTag').val('Medico');
			$('.setInput.isPro').show();
		} else {
			$('#isTel').val('');
			$('#isMat').val('');
			$('#isEsp').val('');
			$('#isTag').val('');
			$('.setInput.isPro').hide()
		}
	})

	/* ---------------------------------------- */
	/* ----- >>> Stick Header ----------------- */
	/* ---------------------------------------- */

	$(function () {
		var setTarget = $('header');
		var setObject = $(window).height() / 10;
		var setSlider = $(window).height();
		var setWindow = $(window);
		var setScroll = setWindow.scrollTop();
		if (setObject != 0 ) {
			setWindow.scroll(function () {
				var setScroll = setWindow.scrollTop();
				if (setScroll > setObject) {
					setTarget.addClass('onTop')
				} else {
					setTarget.removeClass('onTop');
				}
			});
		} else {
			setTarget.addClass('onTop');
		}
	});

	/* ---------------------------------------- */
	/* ----- >>> Menu ------------------------- */
	/* ---------------------------------------- */

	var setMenu;

	$('nav > ul > li > a[href^="#"]').click( function(e) {
		var setTarget = $(this).attr('href');
		$('.setOptions > div').removeClass('isCurrent').slideUp(100);
		$('nav > ul > li > a ' ).removeClass('isCurrent');
		$('#isSRC').slideUp(100);

		$(this).addClass('isCurrent');
		$(setTarget).slideDown(100);
		e.preventDefault()
	});

	$('header').mouseleave(function(){
		$('.setOptions > div').removeClass('isCurrent').slideUp(100);
		$('#isSRC').slideUp(100);
	});

	$('.getCRT, #isCRT .setClose').click( function(e) {
		var setTarget = $('#isCRT');
		var setWidth  = $('#isCRT').outerWidth();

		setTarget.toggleClass('setOpen');
		if (setTarget.hasClass('setOpen')) {
			setTarget.animate({ right: '0px' }, 250);
		} else {
			 setTarget.animate({ right: -setWidth}, 250);  
		}
		e.preventDefault();

	});

	$('.getSRC').click( function(e) {
		var setTarget = $('#isSRC');
		$('.setOptions > div').removeClass('isCurrent').slideUp(100);
		$('nav > ul > li > a ' ).removeClass('isCurrent');
		$(setTarget).slideDown(100);
		e.preventDefault();
	});

	/* ---------------------------------------- */
	/* ----- >>> Modal ------------------------ */
	/* ---------------------------------------- */

	var setCookies = Cookies.get('setModal');	

	$('.setModal .setClose').click( function() {
		var setExpire = new Date(new Date().getTime() + 15 * 60 * 1000);
		Cookies.set('setModal', 'isShown',{expires: setExpire});
		$('.setModal').fadeOut('fast');
	})

	if (setCookies != 'isShown') {
		$('.setModal').css('display', 'flex').show();
	} else {
		$('.setModal').hide();
	}
	
	/* ---------------------------------------- */
	/* ----- >>> Header Fixed ----------------- */
	/* ---------------------------------------- */

	$(function () {
		if($('.setItems').length > 0) {
			var setTarget = $('.setItems');
			var setObject = setTarget.offset().top - $('header').height();
			var setWindow = $(window);
			var setScroll = setWindow.scrollTop() 
			if (setObject != 0 ) {
				setWindow.scroll(function () {
					var setScroll = setWindow.scrollTop()
					if (setScroll > setObject) {
						setTarget.addClass('onTop')
						setTarget.css({'position': 'fixed','top': $('header').height()});
					} else {
						setTarget.removeClass('onTop')
						setTarget.css({'position': 'absolute','top': 24});
					}
				});
			} else {
				setTarget.css({'position': 'fixed','top': $('header').height()});
			}
		}
	});

	/* ---------------------------------------- */
	/* ----- >>> Slide Content ---------------- */
	/* ---------------------------------------- */

	$('.setNotify').slick({
		autoplay		: true,
		autoplaySpeed	: 4000,
		pauseOnHover	: true,
		infinite		: true,
		centerMode		: true,
		arrows			: false, 
		swipe			: false,
		dots			: false,
		slidesToShow	: 1,
		slidesToScroll	: 1,
	})

	$('.setCover, .setBanner').each(function() {
		var autoplaySpeed = $(this).data('autoplay') ? Number($(this).data('autoplay')) * 1000 : 0;
		$(this).slick({
			autoplay		: autoplaySpeed > 0,
			autoplaySpeed	: autoplaySpeed,
			pauseOnHover	: true,
			infinite		: true,
			arrows			: true, 
			swipe			: true,
			dots			: true
		});
	});

	$('.setVideos').slick({
		autoplay		: true,
		pauseOnHover	: true,
		autoplaySpeed	: 15000,
		infinite		: true,
		arrows			: true, 
		swipe			: true,
		dots			: true
	})
	
	$('.setProfessionals').slick({
		autoplay		: false,
		pauseOnHover	: true,
		infinite		: true,
		arrows			: true, 
		swipe			: true,
		dots			: false
	})

	$('.setFAQs').slick({
		autoplay		: false,
		pauseOnHover	: true,
		infinite		: true,
		arrows			: true, 
		swipe			: true,
		dots			: true
	})
	
	$('.setSlider').not('.setProducts').slick({
		autoplay		: true,
		pauseOnHover	: true,
		infinite		: true,
		arrows			: true,
		dots			: false, 
		swipe			: true,
		slidesToShow	: 3,
		slidesToScroll	: 3,
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow 	: 3,
				slidesToScroll 	: 3
			}
		  },{
			breakpoint: 768,
			settings: {
				slidesToShow 	: 2,
				slidesToScroll 	: 2
			}
		  },{
			breakpoint: 480,
			settings: {
				slidesToShow 	: 1,
				slidesToScroll 	: 1
			}
		}]
	})

	$('.setReview').slick({
		autoplay		: true,
		pauseOnHover	: true,
		infinite		: true,
		arrows			: true, 
		swipe			: true,
		slidesToShow 	: 2,
		slidesToScroll 	: 2,
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow 	: 2,
				slidesToScroll 	: 2
			}
		  },{
			breakpoint: 768,
			settings: {
				slidesToShow 	: 2,
				slidesToScroll 	: 2
			}
		  },{
			breakpoint: 480,
			settings: {
				slidesToShow 	: 1,
				slidesToScroll 	: 1
			}
		}]
	})

	$('.setProducts.setSlide').each( function(ID,value) {
		/*var getMin    = $(this).data('min');
		var getMax    = $(this).data('max');
		var getGap    = $(this).data('gap');
		var getSlide  = $(this).data('slide');

					$(this).addClass('isS000'+ID)
		$('.setPrev', this).addClass('isP000'+ID)
		$('.setNext', this).addClass('isN000'+ID)
		$('.setDots', this).addClass('isD000'+ID)

		var setSwiper = new Swiper($('.isS000'+ID), {
			watchSlidesVisibility	: true,
			watchSlidesProgress		: true,
			slideToClickedSlide		: false,
			centeredSlidesBounds	: false,
			watchOverflow			: true,
			slidesPerView			: getMin,
			spaceBetween			: getGap,
			wrapperClass			: 'setItems',
			slideClass				: 'setItem',
			speed					: 750,
			loop					: true,
			autoplay				: getSlide,
			navigation				  : {
				prevEl				: '.isP000'+ID,
				nextEl				: '.isN000'+ID,
			},
			pagination				: {
				bulletActiveClass	: 'isActive',
				el					: '.isD000'+ID,
				bulletClass			: 'setDot',
				clickable			: true
			},
			slidesPerColumnFill		: 'row',
			breakpoints				: {
				640: {
					spaceBetween	: getGap,
					slidesPerView	: getMin,
				},
				1024: {
					slidesPerView	: getMax,
					spaceBetween	: getGap,
				}
			},
		});*/
		$(this).addClass('isS000'+ID);
		console.log(ID);
		$('.isS000'+ID).slick({
			autoplay		: true,
			pauseOnHover	: true,
			infinite		: true,
			arrows			: true, 
			swipe			: true,
			dots 			: true,
			slidesToShow 	: 3,
			slidesToScroll 	: 3,
			responsive: [{
				breakpoint: 1024,
				settings: {
					slidesToShow 	: 3,
					slidesToScroll 	: 3
				}
			},{
				breakpoint: 768,
				settings: {
					slidesToShow 	: 2,
					slidesToScroll 	: 2
				}
			},{
				breakpoint: 480,
				settings: {
					slidesToShow 	: 1,
					slidesToScroll 	: 1
				}
			}]
		})
	});

	/* ---------------------------------------- */
	/* ----- >>> Media Accordion -------------- */
	/* ---------------------------------------- */

	$('.setAccor dd:nth-child(2)').addClass('isCRT');

	if ($('#getFiles').length) {
		(function ($) {
			$('dl > dd').hide();
			jQuery('dl > dt').on('click', function () {
				$this = $(this);
				$target = $this.next();
				if (!$this.hasClass('isOpen')) {
					$this.parent().children('dd').slideUp('fast');
					jQuery('dl > dt').removeClass('isOpen');
					jQuery('dl > dt').addClass('isClosed');
					$target.addClass('isActive').slideDown('fast');
					$this.addClass('isOpen');
				} else {
					jQuery('dl > dt').removeClass('isClosed');
					$this.parent().children('dd').slideUp('fast');
					jQuery('dl > dt').removeClass('isOpen');
				}
				return false;
			});
		})(jQuery);
	}

	if ($('.setAccor').length) {
		(function ($) {
			$('dl > dd').hide();
			jQuery('dl > dt').on('click', function () {
				$this = $(this);
				$target = $this.next();
				if (!$this.hasClass('isOpen')) {
					$this.parent().children('dd').slideUp('fast');
					jQuery('dl > dt').removeClass('isOpen');
					jQuery('dl > dt').addClass('isClosed');
					$target.addClass('isActive').slideDown('fast');
					$this.addClass('isOpen');
				} else {
					jQuery('dl > dt').removeClass('isClosed');
					$this.parent().children('dd').slideUp('fast');
					jQuery('dl > dt').removeClass('isOpen');
				}
				return false;
			});
		})(jQuery);
	}

	if($(window).width() < 640) {
		/*(function ($) {
			$('dl > dd').hide();
			jQuery('dl > dt').on('click', function () {
				$this = $(this);
				$target = $this.next();
				if (!$this.hasClass('isOpen')) {
					$this.parent().children('dd').slideUp('fast');
					jQuery('dl > dt').removeClass('isOpen');
					jQuery('dl > dt').addClass('isClosed');
					$target.addClass('isActive').slideDown('fast');
					$this.addClass('isOpen');
				} else {
					jQuery('dl > dt').removeClass('isClosed');
					$this.parent().children('dd').slideUp('fast');
					jQuery('dl > dt').removeClass('isOpen');
				}
				return false;
			});
		})(jQuery);*/
	} else {
		$('.setLinks li:nth-child(1)').addClass('setACT');
		$('.setLinks li').click(function() {
			var setTarget = '#'+$(this).data('ref');
			if (!$(this).hasClass('setACT')) {
				$('.setLinks li').removeClass('setACT');
				$(this).addClass('setACT');
				$('dl .isCRT').slideUp(300).removeClass('isCRT');
				$(setTarget).slideDown(300).addClass('isCRT');
			}
		})
	}

	$('.setCategory li a[href*="mailto"]').click(function(e) {
		var setTarget = $(this).parent()
		if (!setTarget.hasClass('isCurrent')) {
			$('.setFilter').slideDown(300);
			setTarget.addClass('isCurrent');
		} else {
			setTarget.removeClass('isCurrent');
			$('.setFilter').slideUp(300);
		}
		e.preventDefault();
	})

	/* ---------------------------------------- */

	$('.getLogin, .getReset').click( function(event) {
		var setTarget = $(this).attr('href');
		$('.isOpen').slideToggle(0).removeClass('isOpen')
		$(setTarget).slideToggle(0).addClass('isOpen');
		event.preventDefault();
	})
	
	$('.getEdit').click( function(event) {
		var setTarget = $(this).attr('href');
		$('.isOpen').slideToggle(0).removeClass('isOpen')
		$(setTarget).slideToggle(0).addClass('isOpen');
		event.preventDefault();
	})

	$('.getClose').click( function(event) {
		$('.isOpen').slideToggle(0).removeClass('isOpen')
		$('#isADS00').slideToggle(0).addClass('isOpen');
		event.preventDefault();
	})

	$('.getRemove').click( function(event) {
		var setTarget = $(this).attr('href');
		$(setTarget).trigger('click');
		event.preventDefault();
	})

	$('.getSwitch').click( function() {
		$('.setPlayer.setDSK').slideToggle();
		$('.setPlayer.setMBL').slideToggle();
	})

	/* ---------------------------------------- */
	/* ----- >>> Variants --------------------- */
	/* ---------------------------------------- */

	$('#setVariants').change(function() {
		var getValue = $(this).val()
		var getStock = $(this).find(':selected').data('stock');
		$.each(getJSON.variants, function(i){
			if ( getValue == getJSON.variants[i].id) {
				var setAVL = getJSON.variants[i].available;
				var setAVL = getJSON.variants[i].available;
				var setPRC = getJSON.variants[i].price;
				var setCMP = getJSON.variants[i].compare_at_price;
				
				if (setAVL == true) {
					$('.addToCart').val('Agregar').attr('disabled', false);
					$('.setQuantity .setQty').attr('max',getStock);
					$('.setQuantity .setQty').val(1)
					$('.setQuantity .setLess').attr('disabled', false);
					$('.setQuantity .setMore').attr('disabled', false);
				} else {
					$('.addToCart').val('Agotado').attr('disabled', true);
					$('.setQuantity .setQty').attr('max',0);
					$('.setQuantity .setQty').val(0)
					$('.setQuantity .setLess').attr('disabled', true);
					$('.setQuantity .setMore').attr('disabled', true);
				}

				$('.setPrice em').text(getMoney(setPRC));
				
				if (setCMP != null) {
					$('.setPrice del').text(getMoney(setCMP));
				} else {
					$('.setPrice del').text('');
				}
			}

		})
	});

	function getMoney (setVar) {
		var getBills = setVar.toString().slice(0, -2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
		var getCents = setVar.toString().substr(-2)
		return '$'+getBills+'.'+getCents;
	}

	/* ---------------------------------------- */
	/* ----- >>> Cart Quantity ---------------- */
	/* ---------------------------------------- */

	$('#getCart').getUpdate({
		getItem 	: '.setItem',
		getQtty		: '.setQty',
		getSbtl		: '.setMath',
		getTotal	: '.setTotal',
		getItems 	: '.setCount'
	});

	$('.setLess').click( function() {
		var setInput = $(this).parent().find('.setQty')
		var setLimit = setInput.attr('min');
		var setValue = +setInput.val() - 1
		if ( setValue >= setLimit ) {
			setInput.val( setValue ).blur();
		}
		return false;
	})
	
	$('.setMore').click( function() {
		var setInput = $(this).parent().find('.setQty')
		var setLimit = setInput.attr('max');
		var setValue = +setInput.val() + 1
		if ( setValue <= setLimit ) {
			setInput.val( setValue ).blur();
		}
		return false;
	})

	/* ---------------------------------------- */
	/* ----- >>> Quiz ----------------------- */
	/* ---------------------------------------- */

	$('.setSwiper').slick({
		autoplay		: false,
		pauseOnHover	: true,
		infinite		: false,
		arrows			: true, 
		swipe			: false,
		dots			: true
	})

	$('.setSwiper').on('beforeChange', function (event, slick, index) {
		if (index == 0) {
			$('.setSwiper .setNext, .setSwiper .setDots').css('opacity',1);
		} else if (index == 13) { 
			console.log('Final');
			$('.setSwiper .setNext').css('opacity', 0);
		} else if ( index > 0) {
			$('.setSwiper .setPrev').css('opacity', 1);
		}



		var DEF = 0;
		var KOL = 0;
		var MIND = 0;
		var DENT = 0;
		var NAME = $('#isName').val();

		$('.setSwiper ul > li.isSelected').each(function( index ) {
			isProds = $(this).data('product');
			isValue = $(this).data('value');

			if(isProds == 'DEF')  { DEF  = DEF  + isValue; }
			if(isProds == 'KOL')  { KOL  = KOL  + isValue; }
			if(isProds == 'MIND') { MIND = MIND + isValue; }
			if(isProds == 'DENT') { DENT = DENT + isValue; }

		});

		console.log(DEF, KOL, MIND, DENT);

		if (DEF  >= 15) { $('.isC01').css('display','flex'); }
		if (KOL  >= 15) { $('.isC02').css('display','flex'); }
		if (MIND >= 15) { $('.isC03').css('display','flex'); }
		if (DENT >= 15) { $('.isC04').css('display','flex'); }

		console.log(NAME);

		$('.isName').text(NAME)

	})

	$('a[href*="#isStart"]').click(function(e) {
		 $(".setSwiper").slick('slickNext');
		e.preventDefault();
	});


	$('.setSwiper ul > li').click(function(){
		$(this).parent().find('li').removeClass('isSelected');
		$(this).addClass('isSelected');
	});

	/* ---------------------------------------- */
	/* ----- >>> Resize ----------------------- */
	/* ---------------------------------------- */

	$( window ).resize(function() {
		setResize();
	});

	function setResize() {
		var setRef = $('#isNST .setREF').height() - 64;
		$('#isNST .setBG').height(setRef);
		var setRef = $('#isABT .setREF').height() + 160;
		$('#isABT .setBG').height(setRef);
	}

	setResize();

	/* ---------------------------------------- */
	/* ----- >>> Mailto Links ----------------- */
	/* ---------------------------------------- */

	var siteDomain = '@biohelper.com.ar';
	$('a[href*="mailto"]').not('.isExclude').not(':contains("@")').each(function () {
		$(this).attr('href', function (index, value) {
			return (value + siteDomain);
		});
		$(this).not('.exclude').text(function (index, text) {
			return (text + siteDomain);
		});
	});

	/* ---------------------------------------- */
	/* ----- >>> Set Uniform Js --------------- */
	/* ---------------------------------------- */

	$('select, input[type=checkbox], input[type=radio], input[type=file]').uniform();

});